const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  userid: state => state.user.userid,
  usercode: state => state.user.usercode,
  name: state => state.user.name,
  roles: state => state.user.roles,
  keeper: state => state.user.keeper,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews
}

export default getters
